/**
 * Version utility for The Onescent Dial
 * Provides centralized version management and cache-busting support
 */

// Import version from root VERSION.json
// This is bundled at build time by webpack
export const APP_VERSION = '3.69';
export const APP_PHASE = 'pre-beta';
export const BUILD_DATE = '2026-03-08';

/**
 * Get formatted version string
 */
export const getVersionString = () => `v${APP_VERSION}`;

/**
 * Get version info object
 */
export const getVersionInfo = () => ({
  version: APP_VERSION,
  phase: APP_PHASE,
  buildDate: BUILD_DATE,
  fullVersion: `v${APP_VERSION}-${APP_PHASE}`
});

/**
 * Generate cache-bust query parameter
 * Uses version + timestamp for unique cache keys
 */
export const getCacheBustParam = () => {
  const timestamp = Math.floor(Date.now() / (1000 * 60 * 60)); // Changes every hour
  return `v=${APP_VERSION}&t=${timestamp}`;
};

export default {
  APP_VERSION,
  APP_PHASE,
  BUILD_DATE,
  getVersionString,
  getVersionInfo,
  getCacheBustParam
};
